import { render, staticRenderFns } from "./RegisterMail.vue?vue&type=template&id=6b480013&scoped=true&"
import script from "./RegisterMail.vue?vue&type=script&lang=js&"
export * from "./RegisterMail.vue?vue&type=script&lang=js&"
import style0 from "./RegisterMail.vue?vue&type=style&index=0&id=6b480013&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b480013",
  null
  
)

export default component.exports